import {
  FacilityClassification,
  FacilityDto,
  FacilityStatus,
  PagedResultDto
} from '@umss/shared/data-access';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export const facilityMock: FacilityDto = {
  facilityTypeId: 1,
  facilityTypeName: 'Hospital',
  facilityTypeHasSubtypes: true,
  classification: FacilityClassification.STANDARD,
  classificationDisplay: 'Standard',
  status: FacilityStatus.Active,
  statusDisplay: '',
  location: {
    id: 0,
    addressLine1: 'Calle St Ln 8 ',
    addressLine2: '',
    city: 'Salt Lake City',
    stateCode: 'UT',
    stateName: 'Utah',
    zipCode: '15832',
    countryCode: 'US',
    fullAddress: 'Calle St Ln 8 , Salt Lake City'
  },
  contactPhone: '981-292-6560',
  contactEmail: 'AlexMamani@huro.com',
  websiteUrl: '',
  onboardingCompleted: true,
  supportedScopes: [
    ScopeOfPracticeEnum.RtResp,
    ScopeOfPracticeEnum.Phlebotomist
  ],
  contacts: [],
  distanceMiles: 3.9,
  isFavorite: false,
  name: 'El Curandero',
  description: '',
  isActive: true,
  id: '86c3ab3c-04a1-4e87-9623-168bac56f7ec',
  createdAt: '2025-12-17T13:27:49.730921Z',
  updatedAt: '2025-12-17T14:46:15.02401Z',
  billingManagedByCorporate: false
};
export const facilityPagedResultMock: PagedResultDto<FacilityDto> = {
  items: [facilityMock],
  totalCount: 21,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 3,
  hasPreviousPage: false,
  hasNextPage: true
};
